"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("gather-common-including-video/dist/src/public/axios");
const axiosClientEventEmitter_1 = require("./axiosClientEventEmitter");
const axiosErrorHandler = (error) => {
    if (error?.response?.status === 403 && error?.response?.data?.error === "SSO_AUTHENTICATION") {
        axiosClientEventEmitter_1.axiosClientEventEmitter.publishEvent(axiosClientEventEmitter_1.AxiosClientEvent.SSOAuthenticationFailed);
    }
    throw error;
};
const axiosClient = {
    get: (finalPath, axiosConfig) => axios_1.axios
        .get(finalPath, axiosConfig)
        .then((r) => r.data)
        .catch(axiosErrorHandler),
    post: (finalPath, body, axiosConfig) => axios_1.axios
        .post(finalPath, body, axiosConfig)
        .then((r) => r.data)
        .catch(axiosErrorHandler),
    patch: (finalPath, body, axiosConfig) => axios_1.axios
        .patch(finalPath, body, axiosConfig)
        .then((r) => r.data)
        .catch(axiosErrorHandler),
    put: (finalPath, body, axiosConfig) => axios_1.axios
        .put(finalPath, body, axiosConfig)
        .then((r) => r.data)
        .catch(axiosErrorHandler),
    delete: (finalPath, axiosConfig) => axios_1.axios
        .delete(finalPath, axiosConfig)
        .then((r) => r.data)
        .catch(axiosErrorHandler),
};
exports.default = axiosClient;
//# sourceMappingURL=axiosClient.js.map